import React from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../../config/routes';
import ContentAction from '../shared/ContentAction';

export default function ProductCard({ product, number }) {
  const { t } = useTranslation('app');
  const copy = key => t(`productIntro.main.${product.translationId}.${key}`);
  return (
    <article className="product-card">
      <div className="product-card-top">
        <span className="product-card-category">{copy('category')}</span>
        <span className="product-card-number">{String(number).padStart(2, '0')}</span>
      </div>
      <div className="product-card-content">
        <h3>{product.name}</h3>
        {product.fullName && <span className="product-card-full-name">{product.fullName}</span>}
        <p>{copy('description')}</p>
        <div className="product-card-tags">
          {product.tags.map(tag => <span key={tag}>{copy(`tags.${tag}`)}</span>)}
        </div>
      </div>
      <div className="product-card-footer">
        <ContentAction action={{ href: product.path }} className="product-card-primary-button">
          {t('productIntro.main.actions.detail')}<span>→</span>
        </ContentAction>
        <ContentAction action={{ href: ROUTES.resources }} className="product-card-secondary-button">
          {t('productIntro.main.actions.resources')}
        </ContentAction>
      </div>
    </article>
  );
}
